export default __webpack_public_path__ + "static/media/cross.f155fbc8.svg";